import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable({ providedIn: 'root' })
export class ReadPermissionGuard implements CanActivate {
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const permissionName = route.data?.['permissionName'] as string | undefined;
    const serviceMode = route.queryParamMap.get('service')?.toUpperCase();
    const resolvedPermission =
      permissionName === 'Contract Upload' && serviceMode === 'MULTIPLE-STAMP'
        ? 'Contract Multi Estamp'
        : permissionName;
    const parentPermission =
      route.data?.['parentPermissionName'] === undefined
        ? 'Service'
        : route.data['parentPermissionName'];
    const parentPermissionAllowed =
      !parentPermission ||
      this.featureFlagService.hasReadPermission(parentPermission, true);
    // Check the route's own service permission separately from the parent.
    // Missing entries are allowed; an explicit read:false still denies access.
    const childPermissionAllowed = resolvedPermission
      ? this.featureFlagService.hasReadPermission(resolvedPermission, true)
      : false;

    if (
      parentPermissionAllowed &&
      childPermissionAllowed
    ) {
      return true;
    }

    this.router.navigate(['/doqfy/dashboard']);
    return false;
  }
}
